const toNumber = value => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
};

const normalizeLimit = value => {
    const parsed = toNumber(value);
    return parsed !== null && parsed > 0 ? parsed : null;
};

export const getLowStockInventoryItems = (inventory = []) => {
    return inventory
        .map(item => {
            const quantity = toNumber(item?.cantidad) ?? 0;
            const itemLimit = normalizeLimit(item?.limite_recompra);
            const reorderLimit = itemLimit;

            if (!reorderLimit) {
                return null;
            }

            if (quantity > reorderLimit) {
                return null;
            }

            return {
                ...item,
                cantidad: quantity,
                reorderLimit
            };
        })
        .filter(Boolean);
};
